<div class="row g-3 mb-4">
  <!-- Orientation Selection -->
  <div class="col-12 mb-3">
    <label class="form-label" translate>Orientation</label>
    <select [(ngModel)]="component.element.orientation" class="form-select form-select-sm">
      <option value="vertical">Vertical</option>
      <option value="horizontal">Horizontal</option>
    </select>
  </div>

  <!-- Border Width -->
  <div class="col-sm-4 mb-3">
    <label class="form-label" translate>Border Width</label>
    <input
      type="number"
      min="0"
      class="form-control form-control-sm"
      [(ngModel)]="component.element.border_width"
    />
  </div>

  <!-- Border Style Dropdown -->
  <div class="col-sm-4 mb-3">
    <label class="form-label" translate>Border Style</label>
    <div ngbDropdown class="d-block">
      <button class="btn btn-sm w-100 btn-outline-primary" ngbDropdownToggle>
        <div [class]="'separator-style ' + component.element.border_style"></div>
      </button>
      <div ngbDropdownMenu>
        <a ngbDropdownItem (click)="component.element.border_style = 'solid'">
          <div class="separator-style solid"></div>
        </a>
        <a ngbDropdownItem (click)="component.element.border_style = 'dashed'">
          <div class="separator-style dashed"></div>
        </a>
        <a ngbDropdownItem (click)="component.element.border_style = 'dotted'">
          <div class="separator-style dotted"></div>
        </a>
      </div>
    </div>
  </div>

  <!-- Border Color Picker -->
  <div class="col-sm-4 mb-3">
    <label class="form-label" translate>Border Color</label>
    <div class="input-group">
      <span class="input-group-text" [style.background]="component.element.border_color"></span>
      <input
        class="form-control form-control-sm"
        [(colorPicker)]="component.element.border_color"
        [cpPosition]="'bottom'"
        [cpDisableInput]="true"
        [cpAlphaChannel]="'disabled'"
        [cpPositionOffset]="'-100%'"
        [value]="component.element.border_color"
      />
    </div>
  </div>

  <!-- Height Input -->
  <div class="col-sm-6 mb-3">
    <label class="form-label" translate>Height</label>
    <input
      type="number"
      min="1"
      placeholder="Height"
      class="form-control form-control-sm"
      [(ngModel)]="component.element.height"
    />
  </div>
</div>
